import type { Project } from "@/data";
import ProjectCard from "./ProjectCard";

type Props = {
    projects: Project[];
    onSelect: (project: Project) => void;
};

const ProjectGrid = ({ projects, onSelect }: Props) => {
    const visibleProjects = projects.filter((p) => p.enabled);

    return (
            <div className="grid md:grid-cols-3 gap-8">
                {visibleProjects.map((project) => (
                        <ProjectCard
                                key={project.id}
                                project={project}
                                onClick={() => onSelect(project)}
                        />
                ))}
            </div>
    );
};

export default ProjectGrid;
